<template>
    <div>
        <div class="modal-container has-text-centered">
            <div class="notification">
                <button id="xButt" class="delete" @click="$emit('close')"></button>
                <div id="title" class="bottom10 top30"><img src="@/assets/img/fourDotsLogo.png" width="18"/><span class="left3">ALERT</span></div> 
                <div class="top40 alertMessage">{{message}}</div>
                <div class="top60">
                  
                    
                    <button class="button wideButton is-coolGreen" @click="ok">
                        OK
                    </button>
                    <br>
                    <div v-if="callBack" class="top10 cancelButton handCursor" @click="cancel">
                        Cancel
                    </div>

                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {message: String, callBack: Function, payload: Object},
  methods: {
      ok: function(){
          if(this.callBack){
            this.callBack(this.payload)
            this.$emit('close')
            return
          }

          this.$emit('close')
      },
      cancel: function(){
          this.$emit('close')
      }
  }
}
</script>

<style scoped>
    #title{
        font-size: 1.5rem;
    }
    .modal-container{
        width: 350px;
        max-height: 350px;
    }
    .body-bott{
        position: absolute;
        right: 15px;
        bottom: 20px;
        width: 100%;
    }
    .notification{
        height: 100%;
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
   

</style>
